import React, { Component } from "react";
import AsyncSelect from "react-select/lib/Async";
import { connect } from "react-redux";
import { Resources } from "../redux/domainRedux";
import { Get } from "../../../constant/thunk";

class MapCenterPoint extends Component {
  handleChange = value => {
    const location = value.value.split(",")[0].trim();
    this.props.changeCenterLocationPoint(location);
  };

  promiseOptions = async inputValue => {
    if (!this.props.addDomain) {
      this.props.enableUpdateButton(false);
    }
    const result = await this.props.Get(
      Resources.autoCompletePlace(inputValue)
    );
    if (result.status === 200) {
      const {
        data: { predictions }
      } = result;
      return predictions.map(item => ({
        label: item.description,
        value: item.description
      }));
    }
  };

  render() {
    return (
      <AsyncSelect
        onChange={this.handleChange}
        cacheOptions
        value={{ value: this.props.location, label: this.props.location }}
        defaultOptions={{
          value: this.props.location,
          label: this.props.location
        }}
        loadOptions={this.promiseOptions}
      />
    );
  }
}

export default connect(
  null,
  { Get }
)(MapCenterPoint);
